import * as React from 'react';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';
import {StackLegacy} from '../layout/stack/stack-legacy';
import type {PopoverInfoBodyColor} from '../popover-info/popover-info';

import {ClickableStat} from './clickable-stat';
import {MetricHeader} from './metric-header';
import type {SecondaryValueType} from './secondary-value';
import {Stat} from './stat';

export type MetricType = {
    title?: string;
    value: React.ReactNode;
    secondaryValue?: SecondaryValueType;
    bottomRow?: React.ReactNode;
    isCentered?: boolean;
    tooltipInfo?: string | React.ReactNode;
    tooltipBodyColor?: PopoverInfoBodyColor;
    isLoading?: boolean;
    modalComponent?: React.ComponentType<{
        isOpen: boolean;
        onClose: () => void;
    }>;
    clickingNavigatesTo?: string;
    centerAlignHeader?: boolean;
    statIsBold?: boolean;
    valueIcon?: React.ReactNode;
};

type Props = MetricType & {
    size?: 'small' | 'normal' | 'big';
    wrapWithDiv?: boolean;
};

export function Metric(props: Props) {
    const {size = 'big', modalComponent: ModalComponent} = props;
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

    if (props.isLoading) {
        return (
            <div className='flex justify-center'>
                <LoadingIcon size={25} fill={colors.greyLt} />
            </div>
        );
    }

    const statComponent = (
        <StackLegacy spacing={0} alignCenter={props.isCentered}>
            <MetricHeader
                title={props.title}
                tooltipInfo={props.tooltipInfo}
                tooltipBodyColor={props.tooltipBodyColor}
                onHelpClick={ModalComponent ? () => setIsModalOpen(true) : undefined}
                size={size}
                isAlignedCenter={props.centerAlignHeader}
            />
            {props.clickingNavigatesTo ? (
                <ClickableStat
                    clickingNavigatesTo={props.clickingNavigatesTo}
                    value={props.value}
                    secondaryValue={props.secondaryValue}
                />
            ) : (
                <Stat
                    value={props.value}
                    secondaryValue={props.secondaryValue}
                    bottomRow={props.bottomRow}
                    size={size}
                    isCentered={props.isCentered}
                    isBold={props.statIsBold}
                    valueIcon={props.valueIcon}
                />
            )}
            {ModalComponent ? (
                <ModalComponent
                    isOpen={isModalOpen}
                    onClose={() => {
                        setIsModalOpen(false);
                    }}
                />
            ) : undefined}
        </StackLegacy>
    );

    return props.wrapWithDiv ? <div>{statComponent}</div> : statComponent;
}
